import React , { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { StarIcon ,BtnArrow ,BorderPattern } from "../../components/svgIcon";
import {Image} from "react-bootstrap";
import "./_error.scss";
const NotFoundPage = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
      sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <section ref={sectionRef} className="page-not-found section-gap double-gap overflow-hidden pb-5">
        <div className="error-box text-center mx-auto">
          <i className="border-pattern d-block w-100 position-absolute bottom-0 end-0 m-auto rotateReverse360">
              <BorderPattern />
          </i>
          <h2 className="sec-heading text-center mb-sm-4">
              <span className="ff-2 sorry-text">
                <span>Sorry</span>
              </span>
              <span className="ff-2">
                  <span className="star">
                      <i className="blue" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                      <i className="red" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="300"><StarIcon/></i>
                      <i className="yellow" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                  </span>
                  <span data-aos="fade">Page Not Found</span>
              </span>
            </h2>
          <div className="title-404">
              <span>4</span>
              <span className="mid-text"><Image src={cdn_path + 'assets/images/placeonzero.svg'} alt="Cinaa logo" title="Cinaa logo" /></span>
              <span>4</span>
          </div>
          <div className="content">
            <p>The Page Your looking for is doesn't exist. Go to home page and try again</p>
          </div>
          <Link to={`/`} className="btn btn-primary mt-4 mt-sm-5">
            Back To Home <BtnArrow />
          </Link>
          <span className="star-pattern position-absolute z-2 opacity01">
              {["first", "second", "third"].map((name, index) => (
                  <i key={index} className={`star position-relative ${name}`}>
                      <StarIcon />
                  </i>
              ))}
          </span>
          <span className="star-pattern position-absolute z-2 opacity01 second-icon">
              {["first", "second", "third"].map((name, index) => (
                  <i key={index} className={`star position-relative ${name}`}>
                      <StarIcon />
                  </i>
              ))}
          </span>
        </div>
    </section>
  );
};

export default NotFoundPage;